// TEMPORÁRIO — manutenção do banco em 17/10/2026, 07:00–17:00 (BRT).
// Navegar pelas vagas continua liberado; login, candidaturas, banco de talentos
// e indicação ficam bloqueados. Para remover: apagar esta pasta e os usos de
// `useMaintenanceWindow`, `isMaintenanceActive` e `MaintenanceBanner`.

import { useEffect, useState } from 'react'
import { Icon } from 'components/Icon'
import { cookies } from 'lib/cookies'

// Datas absolutas com offset -03:00: o servidor roda em UTC (nunca getHours()).
const START = new Date('2026-10-17T07:00:00-03:00')
const END = new Date('2026-10-17T17:01:00-03:00') // exclusivo: some às 17:01

// Cookie `maintenance_preview=1` força a janela p/ QA; só LIGA o bloqueio.
export const isMaintenanceActive = (now = new Date()): boolean =>
  cookies.get('maintenance_preview') === '1' || (now >= START && now < END)

// Decidido só no cliente: as páginas de vaga são ISR (HTML em cache). Começa
// `false` p/ não divergir da hidratação e vira sozinho às 07:00 e às 17:01.
export const useMaintenanceWindow = (): boolean => {
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false)

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>

    const update = () => {
      setIsMaintenance(isMaintenanceActive())

      const next = [START, END].find(date => date.getTime() > Date.now())
      if (next) timer = setTimeout(update, next.getTime() - Date.now())
    }

    update()

    return () => clearTimeout(timer)
  }, [])

  return isMaintenance
}

export const MaintenanceBanner = () => {
  const isMaintenance = useMaintenanceWindow()

  if (!isMaintenance) return null

  return (
    <div
      role="status"
      className="w-full flex justify-center bg-gradient-to-r from-primary-900 via-primary-700 to-secondary-700 text-white"
    >
      <div className="w-full max-w-7xl flex items-start md:items-center gap-3 px-3 py-3">
        <span className="shrink-0 flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
          <Icon face="schedule" size="md" variant="round" />
        </span>
        <div className="text-body2 leading-snug">
          <p className="font-bold">
            Manutenção programada hoje,{' '}
            <span className="whitespace-nowrap">das 7h às 17h</span>
          </p>
          <p className="text-white/80">
            Você pode continuar navegando pelas vagas. Login, candidaturas e
            atualização de currículo voltam às 17h.
          </p>
        </div>
      </div>
    </div>
  )
}
